import React from 'react';

const About = () => {
  return (
    <section className="about">
      <div className="about-container">
        <div className="about-header">
          <div className="about-header-content">
            <div className="about-overline">EXPERIENCE THAT DELIVERS</div>
            <h2>Building AI before ChatGPT</h2>
            <div className="about-subtitle">Founded by proven AI experts with Fortune 500 and startup experience</div>
          </div>
        </div>        
        <div className="about-content">
          <div className="about-bio">
            <div className="bio-text">
              <div className="bio-content">
                <div className="bio-header">
                  <div className="bio-image-container">
                    <div className="bio-image-wrapper">
                      <div className="bio-image-glow"></div>
                      <img src="/alek_hagopian.jpg" alt="Alek Hagopian" className="profile-image" />
                      <div className="bio-image-overlay">
                        <div className="experience-badge">8+ years in AI</div>
                      </div>
                    </div>
                  </div>
                  <div className="bio-header-text">
                    <h3>Meet Alek Hagopian</h3>
                    <div className="bio-title">Founder & AI Implementation Expert</div>
                  </div>
                </div>
                <p>
                  SolidlyAI is an AI & data implementation consulting firm founded by Alek Hagopian, 
                  a repeat AI founder and former Senior Managing Consultant at Mastercard. 
                  Alek built his first AI company in 2018. The company was acquired in 2021. 
                </p>
                <p>
                  SolidlyAI helps organizations quickly design, build, and deploy AI and data to solve real business problems. 
                </p>
                <div className="bio-highlights">
                  <div className="highlight-item">
                    <span className="highlight-icon">🚀</span>
                    <span>Founded & sold AI company</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">⚡</span>
                    <span>8+ years in AI/ML</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">💼</span>
                    <span>Former Mastercard consultant</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="bio-credentials">
              <div className="credentials-header">
                <h4>Proven Track Record</h4>
              </div>
              <div className="credentials-grid">
                <div className="credential-item">
                  <div className="credential-number">8+</div>
                  <div className="credential-label">years in AI</div>
                </div>
                <div className="credential-item">
                  <div className="credential-number">10+</div>
                  <div className="credential-label">years in data</div>
                </div>
                <div className="credential-item">
                  <div className="credential-number">5</div>
                  <div className="credential-label">startups</div>
                </div>
                <div className="credential-item">
                  <div className="credential-number">3</div>
                  <div className="credential-label">acquisitions</div>
                </div>
              </div>
              <div className="credentials-list">
                <div className="credential-badge">
                  <span className="badge-icon">✓</span>
                  <span>Agentic AI</span>
                </div>
                <div className="credential-badge">
                  <span className="badge-icon">✓</span>
                  <span>Machine learning</span>
                </div>
                <div className="credential-badge">
                  <span className="badge-icon">✓</span>
                  <span>Data engineering</span>
                </div>
                <div className="credential-badge">
                  <span className="badge-icon">✓</span>
                  <span>Enterprise infrastructure</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;